__turbopack_context__.v({
  "banner": "PlaaBanner-module-scss-module__t0udNG__banner",
  "btnPrimary": "PlaaBanner-module-scss-module__t0udNG__btnPrimary",
  "btnSecondary": "PlaaBanner-module-scss-module__t0udNG__btnSecondary",
  "buttons": "PlaaBanner-module-scss-module__t0udNG__buttons",
  "centerContent": "PlaaBanner-module-scss-module__t0udNG__centerContent",
  "dot": "PlaaBanner-module-scss-module__t0udNG__dot",
  "dotActive": "PlaaBanner-module-scss-module__t0udNG__dotActive",
  "dots": "PlaaBanner-module-scss-module__t0udNG__dots",
  "dotsWrapper": "PlaaBanner-module-scss-module__t0udNG__dotsWrapper",
  "emblaContainer": "PlaaBanner-module-scss-module__t0udNG__emblaContainer",
  "emblaSlide": "PlaaBanner-module-scss-module__t0udNG__emblaSlide",
  "emblaSlideTitleOnly": "PlaaBanner-module-scss-module__t0udNG__emblaSlideTitleOnly",
  "emblaViewport": "PlaaBanner-module-scss-module__t0udNG__emblaViewport",
  "highlight": "PlaaBanner-module-scss-module__t0udNG__highlight",
  "iconBox": "PlaaBanner-module-scss-module__t0udNG__iconBox",
  "mobileBanner": "PlaaBanner-module-scss-module__t0udNG__mobileBanner",
  "mobileBannerCompact": "PlaaBanner-module-scss-module__t0udNG__mobileBannerCompact",
  "mobileBannerWrapper": "PlaaBanner-module-scss-module__t0udNG__mobileBannerWrapper",
  "mobileBtnPrimary": "PlaaBanner-module-scss-module__t0udNG__mobileBtnPrimary",
  "mobileBtnSecondary": "PlaaBanner-module-scss-module__t0udNG__mobileBtnSecondary",
  "mobileButtons": "PlaaBanner-module-scss-module__t0udNG__mobileButtons",
  "mobileDate": "PlaaBanner-module-scss-module__t0udNG__mobileDate",
  "mobileEmblaContainer": "PlaaBanner-module-scss-module__t0udNG__mobileEmblaContainer",
  "mobileEmblaSlide": "PlaaBanner-module-scss-module__t0udNG__mobileEmblaSlide",
  "mobileEmblaSlideTitleOnly": "PlaaBanner-module-scss-module__t0udNG__mobileEmblaSlideTitleOnly",
  "mobileEmblaViewport": "PlaaBanner-module-scss-module__t0udNG__mobileEmblaViewport",
  "mobileFooter": "PlaaBanner-module-scss-module__t0udNG__mobileFooter",
  "mobileHideOnCompact": "PlaaBanner-module-scss-module__t0udNG__mobileHideOnCompact",
  "mobilePagination": "PlaaBanner-module-scss-module__t0udNG__mobilePagination",
  "mobilePaginationFixed": "PlaaBanner-module-scss-module__t0udNG__mobilePaginationFixed",
  "mobileSubtitle": "PlaaBanner-module-scss-module__t0udNG__mobileSubtitle",
  "mobileTextGroup": "PlaaBanner-module-scss-module__t0udNG__mobileTextGroup",
  "mobileTitle": "PlaaBanner-module-scss-module__t0udNG__mobileTitle",
  "navBtnLeft": "PlaaBanner-module-scss-module__t0udNG__navBtnLeft",
  "navBtnRight": "PlaaBanner-module-scss-module__t0udNG__navBtnRight",
  "pagination": "PlaaBanner-module-scss-module__t0udNG__pagination",
  "paginationText": "PlaaBanner-module-scss-module__t0udNG__paginationText",
  "separator": "PlaaBanner-module-scss-module__t0udNG__separator",
  "subtitle": "PlaaBanner-module-scss-module__t0udNG__subtitle",
  "textArea": "PlaaBanner-module-scss-module__t0udNG__textArea",
  "title": "PlaaBanner-module-scss-module__t0udNG__title",
});
